import {Field, useFormikContext} from 'formik'
import {InputText} from '@/components/form/InputText'
import {TextArea} from '@/components/form/TextArea'
import {Product} from '../../../../core/_models'
import {Card} from '@/components/Card'

const MetaCard = () => {
  const { values, setFieldValue } = useFormikContext();
  const product = values as Product
  return (
    <Card
      title='Meta'
      collapsable={true}
      id='meta'
      className="card mb-5 mb-xl-8"
    >
      <div className="mb-10">
        <Field
          name="path"
          type="text"
          component={InputText}
          label="Product url"
          description="Enter the product public path."
          placeholder="Public product path"
          required={true}
        />
      </div>
      <div className="mb-10">
        <Field
          name="meta.title"
          type="text"
          component={InputText}
          label="Page Title"
          description="Set a meta tag title. Recommended to be simple and precise keywords."
          placeholder="My product page title"
          required={true}
        />
      </div>
      <div className="mb-10">
        <Field
          name="meta.description"
          type="text"
          component={TextArea}
          rows={3}
          className='form-control resize-none min-h-25px'
          label="Meta Tag Description"
          placeholder="Type your text here ..."
          description="Set a meta tag description to the product for increased SEO ranking."
          required={true}
        />
      </div>
      <div className="mb-10">
        <Field
          name="meta.keywords"
          type="text"
          component={InputText}
          value={product?.meta?.keywords?.join(',')}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const val = e.target.value
            setFieldValue(
              'meta.keywords',
              val.length > 0 ? val.split(',') : []
            )
          }}
          label="Meta Tag Keywords"
          required={true}
        />

        <div className="text-muted fs-7">
          Set a list of keywords that the product is related to. Separate the keywords by adding a comma
          <code>,</code>between each keyword.
        </div>
      </div>
    </Card>
  )
}

export {MetaCard}
